export const getAuthToken = () => "Bearer " + localStorage.getItem("token");
